import { theme } from 'styles/theme/hav-theme'

export const statusBgs = {
  ABERTO: theme.colors.alert.warning.dark,
  FATURADO: theme.colors.alert.success.darker,
  CONCLUIDO: theme.colors.alert.success.dark,
  FATURAMENTO: theme.colors.support.first,
  PROCESSANDO: theme.colors.alert.info.dark,
  CANCELADO: theme.colors.neutral.light,
  PENDENTE: theme.colors.alert.danger.dark,
  ANÁLISE: theme.colors.alert.info.dark,
  RESTRITO: theme.colors.alert.danger.dark,
  'EM RESERVA': theme.colors.support.third,
  'EM REMESSA': theme.colors.support.fourth,
  'EM APROVAÇÃO': theme.colors.alert.warning.dark,
  'ENVIADO AO SAP': theme.colors.support.second
}

export type statusBgKey = keyof typeof statusBgs
